import React, { ReactNode } from "react";
import classNames from "classnames";
import CardBootstrap from "react-bootstrap/Card";
import { Badge, Col, Row } from "react-bootstrap";
import { IconPlay } from "../../../app/components/Icon/Icon.tsx";

type CardModel = {
  title: string;
  content: ReactNode;
  className?: string;
};

type CardWithPictureModel = {
  excerpt?: boolean;
  picture: string;
  title: string;
  content?: string;
  link?: ReactNode;
  className?: string;
};

const Card = ({ title, content }: CardModel) => {
  return (
    <section>
      <h2>{title}</h2>
      <div>{content}</div>
    </section>
  );
};

export const CardWithPicture = ({
  picture,
  title,
  content = "Aucune description",
  link,
  className,
}: CardWithPictureModel) => {
  return (
    <CardBootstrap
      bg={"light"}
      className={classNames(
        className,
        "p-1 p-lg-4 rounded-4 border-0 h-100 pointer",
      )}
    >
      <CardBootstrap.Body className={className}>
        <Row>
          {picture ? (
            <Col xs={3}>
              <CardBootstrap.Img src={picture} className={"rounded-5"} />
              <Row className={"p-3"}>
                <Col
                  xs={"auto"}
                  className={
                    "text-primary d-flex flex-row justify-content-center link"
                  }
                >
                  <Badge
                    bg={"primary-30"}
                    pill
                    className={"me-1 text-text-color text-lowercase fw-bold"}
                  >
                    {link}
                  </Badge>{" "}
                  <span className={"d-none d-md-inline"}>
                    <IconPlay />
                  </span>
                </Col>
              </Row>
            </Col>
          ) : (
            <Col xs={3}>
              <Row className={"p-3"}>
                <Col
                  xs={"auto"}
                  className={
                    "text-primary d-flex flex-row justify-content-center link"
                  }
                >
                  <Badge
                    bg={"primary-30"}
                    pill
                    className={"me-2 text-text-color text-lowercase"}
                  >
                    {link}
                  </Badge>{" "}
                  <IconPlay />
                </Col>
              </Row>
            </Col>
          )}
          <Col xs={9}>
            <CardBootstrap.Title className={"cardTitle"}>
              {" "}
              {title}
            </CardBootstrap.Title>
            <CardBootstrap.Text className={"cardText"}>
              {content}
            </CardBootstrap.Text>
          </Col>
        </Row>
      </CardBootstrap.Body>
    </CardBootstrap>
  );
};

export default Card;
